<template>
    <div class="page">
        <my-header :breadcrumb="breadcrumb"></my-header>
        <div class="content">
            <div class="content-wrap">
                <!--搜索-->
                <el-button type="primary" @click="clickAdd">添加导航</el-button>
                <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
                    <el-form :model="form">
                        <el-form-item label="导航类型" :label-width="formLabelWidth">
                          <el-select v-model="form.typeName" placeholder="请选择" @change="changeType">
                            <el-option
                              v-for="item in arrType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <!--<el-form-item label="所属模块" :label-width="formLabelWidth" v-if="showModule">
                          <el-select v-model="form.moduleName" placeholder="请选择" @change="changeModule">
                            <el-option
                              v-for="item in arrModule"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>-->
                      <el-form-item label="分类列表" :label-width="formLabelWidth" v-if="showCategory">
                        <el-cascader
                          v-model="form.arrCate"
                          :options="options"
                          @change="handleChange"></el-cascader>
                        <!--<el-select v-model="form.cate_name" placeholder="请选择" @change="changeCate">
                          <el-option
                            v-for="item in categoryList"
                            :key="item.cate_id"
                            :label="item.cate_name"
                            :value="item.cate_id">
                          </el-option>
                        </el-select>-->
                      </el-form-item>
                      <el-form-item label="导航名称" :label-width="formLabelWidth">
                        <el-input v-model="form.title" @focus="focusTitle"></el-input>
                      </el-form-item>
                      <el-form-item label="上级导航" :label-width="formLabelWidth">
                        <el-select v-model="form.parentName" placeholder="请选择" @change="changeParent">
                          <el-option
                            v-for="item in tableData"
                            :key="item.nav_id"
                            :label="item.title"
                            :value="item.nav_id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="链接地址" :label-width="formLabelWidth" v-if="showLink">
                        <el-input v-model="form.link"></el-input>
                      </el-form-item>
                        <el-form-item label="显示位置" :label-width="formLabelWidth">
                          <el-radio v-model="form.position" :label="1">头部</el-radio>
                          <el-radio v-model="form.position" :label="2">底部</el-radio>
                          <el-radio v-model="form.position" :label="3">都显示</el-radio>
                          <el-radio v-model="form.position" :label="4">都不显示</el-radio>
                        </el-form-item>
                        <el-form-item label="排序" :label-width="formLabelWidth">
                          <el-input v-model="form.sort_order"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="clickConfirm">确 定</el-button>
                    </div>
                </el-dialog>

              <el-dialog title="文章列表" :visible.sync="dialogArticleTableVisible" class="dialog-article">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item>
                    <el-input v-model="formInline.keyword" placeholder="文章标题/内容"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="clickSearchArticle">查询</el-button>
                  </el-form-item>
                </el-form>
                <el-table :data="articleData" ref="singleTable" highlight-current-row
                          @current-change="handleCurrentChange">
                  <el-table-column property="title" label="文章标题"></el-table-column>
                  <el-table-column property="acategory.cate_name" label="文章分类"></el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalCount" :page-size="10" class="page-wrap">
                </el-pagination>
              </el-dialog>
              <el-dialog title="产品列表" :visible.sync="dialogProductTableVisible">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item>
                    <el-input v-model="formInline.keyword" placeholder="产品标题/内容"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="clickSearchProduct">查询</el-button>
                  </el-form-item>
                </el-form>
                <el-table :data="productData">
                  <el-table-column property="date" label="日期" width="150"></el-table-column>
                  <el-table-column property="name" label="姓名" width="200"></el-table-column>
                  <el-table-column property="address" label="地址"></el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalCount" :page-size="10" class="page-wrap">
                </el-pagination>
              </el-dialog>
                <!-- 工具栏（列表名称、列表显示项设置） -->
                <!--列表内容-->

                <el-table
                        :data="tableData"
                        style="width: 100%;margin:10px 0 0 0;"
                        row-key="nav_id"
                        default-expand-all
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        :default-sort="{prop: 'sort_order', order: 'ascending'}"
                >
                    <el-table-column
                            prop="nav_id"
                            label="ID"
                            sortable
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            label="导航名称"
                            sortable
                            width="380">
                    </el-table-column>
                    <el-table-column
                            prop="typeName"
                            label="导航类型">
                    </el-table-column>
                    <!--<el-table-column
                            prop="moduleName"
                            label="所属模块">
                    </el-table-column>-->
                    <el-table-column
                            prop="positionName"
                            label="显示位置">
                    </el-table-column>
                    <el-table-column
                            prop="sort_order"
                            label="排序">
                    </el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    @click="handleEdit(scope.$index, scope.row)">编辑
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    @click="handleDelete(scope.$index, scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="totalCount" :page-size="10" class="page-wrap">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import MyHeader from "../header";
    import Cookies from "js-cookie"
    export default {
        name: "index",
        components: {
            MyHeader
        },
        data() {
            return {
                form: {
                  parentName:'',
                  typeName:'',
                  moduleName:'',
                  position:3
                },
                formLabelWidth:'120px',
                tableData: [],
                totalCount: 0,
                pageCount: 1,
                breadcrumb: [
                    {name: '网站导航'},
                    {name: '导航列表'}
                ],
                dialogFormVisible:false,
              arrType:[
                {label:'文章',value:1},
                {label:'文章分类',value:2},
                {label:'产品',value:3},
                {label:'产品分类',value:4},
                /*{label:'单页面',value:5},*/
                {label:'外部链接',value:6}
              ],
              arrModule:[

              ],
              showCategory:false,
              showLink:false,
              dialogTitle:'添加导航',
              categoryList:[
                {cate_id:0,cate_name:'所有类别'}
              ],
              parentList:[],
              dialogArticleTableVisible:false,
              dialogProductTableVisible:false,
              formInline:{},
              articleData:[],
              productData:[],
              options:[{value:0,label:'所有类别'}]
            }
        },
        created(){
          this.form.nav_id = this.$route.query.id;
            this.$http.get(this.apiUrl+'/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                this.tableData = data.result;
            })

        },
        methods:{
            clickAdd(){
              this.dialogTitle = '添加导航';
                this.dialogFormVisible = true;
                this.form  = {
                  position:3
                }
            },
            clickConfirm(){
              if (this.form.type == 2 || this.form.type == 4){
                this.form.category_id = this.form.arrCate[this.form.arrCate.length-1];
              }

              if (!this.form.nav_id){
                this.form.site_id = Cookies.get('siteId');
              }

              this.$http.post('/v1/nav/save',this.form).then(({data})=>{
                if (data.errcode == 0){
                  this.$message.success(data.msg);
                  this.dialogFormVisible = false;
                  this.$http.get(this.apiUrl+'/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                    this.tableData = data.result;
                  })
                }else{
                  this.$message.error(data.msg);
                }
              })
            },
            handleEdit(index,row){
              var _this = this;
                this.dialogFormVisible = true;
              this.dialogTitle = '修改导航';
                this.$http.get(this.apiUrl+'/v1/nav/view?navId='+row.nav_id).then(({data})=>{
                    this.form = data.result;
                  if(this.form.type == 2){
                    this.showCategory = true;
                    this.$http.get('/v1/acategory/children',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                      if (data.errcode == 0){
                        this.options = this.options.concat(data.result);
                      }
                    })
                  }
                  if(this.form.type == 4){
                    this.showCategory = true;
                    this.$http.get('/v1/category/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                      this.options = this.options.concat(data);
                        //console.log(this.options)
                    })
                  }
                  if (this.form.module_id == 1){
                    this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
                      this.categoryList = data.result;
                      this.categoryList.forEach(function (item) {
                          if (item.cate_id == _this.form.category_id){
                            _this.form.cate_name = item.cate_name;
                          }
                      })
                    })
                  }
                  this.tableData.forEach(function (item) {
                    if (item.nav_id == _this.form.parent_id){
                      _this.form.parentName = item.title;
                    }
                  })
                })
            },
            handleDelete(index,row){
              this.$http.delete('/v1/nav/delete?navId='+row.nav_id).then(({data})=>{
                if (data.errcode == 0){
                  this.$message.success(data.msg);
                  this.$http.get(this.apiUrl+'/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                    this.tableData = data.result;
                  })
                }else{
                  this.$message.error(data.msg)
                }
              })
            },
          changeType(val){
              this.form.type = val;
              if (val == 1){
                this.dialogArticleTableVisible = true;
                this.showLink = false;
                this.showCategory = false;
                this.$http.get('/v1/article/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                  if (data.errcode == 0){
                      this.articleData = data.result.list;
                  }
                })
              }else if (val == 3){
                this.dialogProductTableVisible = true;
                this.showLink = false;
                this.showCategory = false;
                this.$http.get('/v1/product/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                  if (data.errcode == 0){
                    this.productData = data.result.list;
                  }
                })
              }else if (val == 2){
                this.showCategory = true;
                this.showLink = false;
                this.$http.get('/v1/acategory/children',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                  if (data.errcode == 0){
                    this.articleOptions = data.result;
                  }
                })
              }else if (val == 6){
                this.showLink = true;
                this.showCategory = false;
              }
          },
          changeModule(val){
            this.form.module_id = val;
            if (val == 1){
              this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
                this.categoryList.concat(data.result);
              })
            }

          },
          changeCate(val){
              var _this = this;
            this.form.category_id = val;
            if (!this.form.nav_id){
              this.categoryList.forEach(function (item) {
                if(item.cate_id == val){
                  _this.form.title =  item.cate_name;
                }
              })
            }

          },
          changeParent(val){
              var _this = this;
            this.form.parent_id  = val;
            this.tableData.forEach(function (item) {
                if (item.nav_id == val){
                  _this.form.parentName = item.title;
                }
            })
          },
          clickSearchArticle(){

          },
          clickSearchProduct(){

          },
          handleCurrentChange(row){
            this.form.title = row.title;
            this.dialogArticleTableVisible = false;
            this.form.link = '/article/view?id='+row.article_id;
          },
          handleChange(value){
              var _this = this;
              this.form.category_id = value;
              if (this.form.type == 2){
                if (value == 0){
                  this.form.link = '/article/list';
                }else{
                  this.form.link = '/article/list?cateId='+value;
                }
              }else if (this.form.type == 4){
                if (value == 0){
                  this.form.link = '/product/list';
                }else{
                  this.form.link = '/product/list?cateId='+value;
                }
              }
            this.options.forEach(function (item) {
              if (value == item.value){
                _this.form.title = item.label;
              }
            })
          },
          focusTitle(){
              if (this.form.type == 1){
                this.dialogArticleTableVisible = true;
                this.$http.get('/v1/article/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                  if (data.errcode == 0){
                    this.articleData = data.result.list;
                  }
                })
              }
          }
        }
    }
</script>

<style scoped>
    .page-wrap{
        float: right;
        margin:30px 0 0 0;
    }
    .content-wrap >>> .el-dialog__body{
      overflow: hidden;
    }
</style>
